// Fachada do domínio Goals — métodos da instância (ver core.ts).
import { goalsService } from './core';
import { GOAL_SCOPES } from '@modules/goals';

// ─── Operações com dados (via adapter) ──────────────────────────
export const listGoals             = goalsService.listGoals;
export const upsertGoal            = goalsService.upsertGoal;
export const deleteGoal            = goalsService.deleteGoal;
export const copyFromPreviousMonth = goalsService.copyFromPreviousMonth;
export const getGoalsAchievement   = goalsService.getGoalsAchievement;

// ─── Constantes puras (reexportadas do módulo) ──────────────────
export { GOAL_SCOPES };

// ─── Tipos ──────────────────────────────────────────────────────
export type {
  GoalScopeInfo,
  ListGoalsParams,
  UpsertGoalParams,
  CopyFromPreviousMonthParams,
  GetGoalsAchievementParams,
} from '@modules/goals';
